import { QueryClient } from "@tanstack/react-query";

// The BI SPA's single TanStack Query client. No default refetchInterval:
// bi-query.ts polls pending charts (Pusher `private-bi-{email}` is only the fast
// path), and queries.ts polls a few job states only while they are pending.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
